export let EComparisonNotificationCategory = /*#__PURE__*/function (EComparisonNotificationCategory) {
  EComparisonNotificationCategory["Add"] = "add";
  EComparisonNotificationCategory["Limit"] = "limit";
  EComparisonNotificationCategory["Remove"] = "remove";
  return EComparisonNotificationCategory;
}({});